import {deleteEventImage} from '../../../service/events/events-api';
import {useUploadEventImage} from '../../../service/events/events-hook';
import {EventFormFieldsEnum, EventFormType} from '../../../service/events/events-type';
import {Form} from '../../../typings/antd';
import {noop} from '../../../util/function';
import {PublicationMediaStep} from '../../publication-wizard/publication-media-step';
import {Text} from '../../text/text';

// Yandex help for events: JPG/PNG, up to 4 images, 320 × 160 … 5000 × 5000 px, recommended 400 × 160.
const EVENT_MAX_IMAGES = 4;
const EVENT_MEDIA_MIN_WIDTH = 320;
const EVENT_MEDIA_MIN_HEIGHT = 160;
const EVENT_MEDIA_MAX_WIDTH = 5000;
const EVENT_MEDIA_MAX_HEIGHT = 5000;
const EVENT_MEDIA_RECOMMENDED_WIDTH = 400;
const EVENT_MEDIA_RECOMMENDED_HEIGHT = 160;

type PropsType = {
    onPreviousStep: VoidFunction;
    onStepFinished: VoidFunction;
    onStepActivated: (width: number) => void;
    width: number;
};

const banner = (
    <>
        <Text block bolder stringKey="EVENTS__FORM__UPLOAD_IMAGES__COUNT" />
        <Text block stringKey="YANDEX_STORY_FORM__UPLOAD_IMAGES__RULES_2" />
        <Text
            block
            stringKey="EVENTS__FORM__UPLOAD_IMAGES__RESOLUTION"
            valueMap={{
                maxHeight: EVENT_MEDIA_MAX_HEIGHT,
                maxWidth: EVENT_MEDIA_MAX_WIDTH,
                minHeight: EVENT_MEDIA_MIN_HEIGHT,
                minWidth: EVENT_MEDIA_MIN_WIDTH,
                recommendedHeight: EVENT_MEDIA_RECOMMENDED_HEIGHT,
                recommendedWidth: EVENT_MEDIA_RECOMMENDED_WIDTH,
            }}
        />
    </>
);

// Multiple images for events.
export function EventMediaStep(props: PropsType): JSX.Element {
    const {onPreviousStep, onStepFinished, onStepActivated, width} = props;

    const {mutateAsync: uploadImage} = useUploadEventImage();

    return (
        <Form.Item<EventFormType> name={EventFormFieldsEnum.Images} noStyle>
            <PublicationMediaStep
                banner={banner}
                maxCount={EVENT_MAX_IMAGES}
                maxHeight={EVENT_MEDIA_MAX_HEIGHT}
                maxWidth={EVENT_MEDIA_MAX_WIDTH}
                minHeight={EVENT_MEDIA_MIN_HEIGHT}
                minWidth={EVENT_MEDIA_MIN_WIDTH}
                onPreviousStep={onPreviousStep}
                onStepActivated={onStepActivated}
                onStepFinished={onStepFinished}
                remove={(imageId) => deleteEventImage(imageId).catch(noop)}
                upload={(file) => uploadImage(file)}
                uploaderHintLangKey="EVENTS__FORM__UPLOAD_IMAGES__UPLOADER_MAX_IMAGES"
                uploaderTextLangKey="YANDEX_STORY_FORM__UPLOAD_IMAGES__UPLOADER_TEXT"
                width={width}
            />
        </Form.Item>
    );
}
